import { MessageAttachment } from './types'
import { Icon } from '@/Atomic/Atoms/Icon'
import { DataImage } from '@/Components/DataImage'
import { DownloadAnchor } from '@/Components/shared/DownloadAnchor'

interface MessageAttachmentPreviewBoxProps {
  messageAttachment: MessageAttachment
  onClick: (attachment: MessageAttachment) => void
  downloadUrl?: string
}

export const MessageAttachmentPreviewBox: React.FC<
  MessageAttachmentPreviewBoxProps
> = ({ messageAttachment, onClick, downloadUrl }) => {
  const isImg = messageAttachment.contentType.includes('image')

  const style = isImg ? {} : { cursor: 'default' }
  const onClickCallback = isImg ? () => onClick(messageAttachment) : undefined

  const fileName = messageAttachment?.filename || 'File'
  const fileSize = `${Math.ceil(messageAttachment.contentLength / 1024)} KB`

  return (
    <div className="jr-box-attachment">
      <div className="jr-box-preview" style={style} onClick={onClickCallback}>
        {isImg ? (
          <DataImage dataBinary={messageAttachment} defaultImage="" />
        ) : (
          <Icon icon="file-empty" />
        )}
      </div>
      <div className="jr-box-meta">
        <div>
          <span className="h6">{fileName}</span>
          <span className="text-small text-meta">{fileSize}</span>
        </div>
        <DownloadAnchor
          url={downloadUrl || ''}
          name={messageAttachment.filename}
          className="download-anchor"
        >
          <Icon size="sm" icon="download-circle" />
        </DownloadAnchor>
      </div>
    </div>
  )
}
